import { generatePath } from 'quartz-routing/react-router';
import { RESULTS_URL_FRAGMENT } from 'academy-common-lib/routes/academyRoutePaths';
import { FILTER_CONSTS, FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
const appendAll = (urlParams, key, value) => {
  if (!value) {
    return;
  }
  const values = Array.isArray(value) ? value : [value];
  values.forEach(entry => {
    if (entry) {
      urlParams.append(key, entry);
    }
  });
};
export const getSearchUrl = ({
  searchTerm,
  language,
  showOnlyCerts,
  tool,
  category,
  contentType,
  contentSource
}) => {
  const urlParams = new URLSearchParams();
  if (searchTerm) urlParams.set(FILTER_TYPES.SEARCH, searchTerm);
  if (contentType) urlParams.set(FILTER_TYPES.CONTENT_TYPE, contentType);
  if (contentSource) urlParams.set(FILTER_TYPES.CONTENT_SOURCE, contentSource);
  if (language) {
    if (Array.isArray(language)) {
      language.forEach(lang => {
        if (typeof lang === 'string') {
          urlParams.append(FILTER_TYPES.LANGUAGE, lang.toUpperCase());
        }
      });
    } else if (typeof language === 'string') {
      urlParams.set(FILTER_TYPES.LANGUAGE, language.toUpperCase());
    }
  }
  if (showOnlyCerts) urlParams.set(FILTER_TYPES.AWARD_TYPE, FILTER_CONSTS.AWARD_TYPES.ONLY_SHOW_CERTIFICATE_COURSES);
  appendAll(urlParams, FILTER_TYPES.TOOLS, tool);
  appendAll(urlParams, FILTER_TYPES.CATEGORY, category);
  const pathname = generatePath(RESULTS_URL_FRAGMENT);
  const search = urlParams.toString().replace(/\+/g, '%20');
  return {
    search,
    pathname,
    hash: '',
    state: undefined,
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};